import { useState } from "react"
import { useTypedSelector } from "../../../app/store"
import DecisionPanel from "./decision-panel"
import PlanPanel from "./plan-panel"

const DecisionPlanSection = () => {
  const [activePanel, setActivePanel] = useState("decision")

  const planCount = useTypedSelector(
    (state) => state.simulationSlice.plans.length,
  )

  const isConnectionPanelOpen = useTypedSelector(
    (state) => state.decisionsSlice.addConnectionOpenFlag,
  )

  const handleDecisionsClick = () => {
    setActivePanel("decision")
  }

  const handlePlansClick = () => {
    setActivePanel("plan")
  }

  return (
    <div className="self-stretch flex flex-1 flex-row items-start justify-start gap-[32px] min-h-0 min-w-0 overflow-hidden">
      <div className="self-stretch flex-1 rounded-xl bg-base-white shadow-[0px_1px_3px_rgba(16,_24,_40,_0.1),_0px_1px_2px_rgba(16,_24,_40,_0.06)] flex flex-col items-start justify-start p-6 gap-[21px] text-primary-700 border-[1px] border-solid border-gray-200 min-h-0 overflow-hidden">
        {!isConnectionPanelOpen && (
          <div className="self-stretch flex flex-row items-center justify-start gap-[8px] flex-shrink-0">
            <button
              id="decisionsMenuButton"
              className={`${
                activePanel === "decision"
                  ? "bg-blue-light-200 font-semibold"
                  : "font-semibold bg-base-white"
              } text-primary-700 hover:bg-lightblue hover:cursor-pointer rounded-md py-2 px-3`}
              onClick={handleDecisionsClick}>
              <div className="relative leading-[20px]">Actions</div>
            </button>
            <button
              id="plansMenuButton"
              className={`${
                activePanel === "plan"
                  ? "bg-blue-light-200 font-semibold"
                  : "font-semibold bg-base-white"
              } text-primary-700 hover:bg-lightblue hover:cursor-pointer rounded-md py-2 px-3`}
              onClick={handlePlansClick}>
              <div className="relative leading-[20px]">
                Plans{" "}
                <div className="badge badge-sm badge-ghost">{planCount}</div>
              </div>
            </button>
          </div>
        )}
        <div className="flex-1 min-h-0 w-full h-full flex flex-col overflow-hidden">
          {activePanel === "decision" && <DecisionPanel />}
          {activePanel === "plan" && <PlanPanel />}
        </div>
      </div>
    </div>
  )
}

export default DecisionPlanSection
